import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import moment from "moment";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Error from "../../ErrorPages/Error";
import PieChartComponent from "./charts/PieChart";
import BarChartComponent from "./charts/BarChart";
import WorkOrderPerformanceMetrix from "./WorkOrderPerformanceMetrix";

const WorkOrder = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();

    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const TypeMasterQueryData = TypeMasterQuery.useFetch({
        params: {
            q: "Work Order Status",
            c: "category",
        },
    });

    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialQueries = searchParams.get("q")?.split(",") || [];
    const initialColumns = searchParams.get("c")?.split(",") || [];

    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [sorting, setSorting] = useState([]);

    const onFGoodsHandler = (row) => {
        console.log(row);
        // navigate("/sales-work-order", {
        //     state: { id: row?.sales_order?.id },
        // });
        navigate("/split-work-order", {
            state: { id: row?.sales_order?.id },
        });
    };

    const { useFetch } = useAPIQuery({
        key: "work_order",
        endpoint: "/api/work-order/",
    });

    const { data, isLoading, isFetching, isError, error } = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
            action: "fetch_work_orders",
            sort_q:
                sorting &&
                sorting
                    ?.map((item) => (item?.desc ? "desc" : "asc"))
                    ?.join(","),
            sort_c: sorting && sorting?.map((item) => item?.id)?.join(","),
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    // const { useDelete } = useAPIQuery({
    //     key: "work_order",
    //     endpoint: "/api/work-order/",
    // });

    // const { mutate: deleteData } = useDelete();

    const handleGlobalFilterChange = (value) => {
        const q = value?.trim() || "";
        if (q !== "") {
            setGlobalFilterValue(q);
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.delete("c");
                return searchParams;
            });
        } else if (q === "") {
            setGlobalFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                return searchParams;
            });
        }
    };

    const handleColumnFilterChange = (value) => {
        const q = value.map((val) => val.value?.trim() || "").join(",");
        const c = value.map((val) => val.id).join(",");
        if (q !== "" && c !== "") {
            setGlobalFilterValue("");
            setColumnFilterKey(c);
            setColumnFilterValue(q);
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.set("c", c);
                return searchParams;
            });
        } else if (q === "" && c === "") {
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                searchParams.delete("c");
                return searchParams;
            });
        }
    };

    const handlePagination = (value) => {
        setSearchParams((searchParams) => {
            searchParams.set("entries", value.pageSize);
            searchParams.set("page", value.pageIndex + 1);
            return searchParams;
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    // const handleEditRow = (row) => {
    //     console.log(row);
    //     // navigate("/edit-work-order", { state: { editpost: row.original } });
    //     navigate("/sales-work-order", {
    //         state: { id: row?.original?.sales_order?.id },
    //     });
    // };

    // const handleDeleteRow = (row) => {
    //     console.log(row);
    //     const entry_id = row.original.id;
    //     Swal.fire({
    //         text: "Are you sure? You will not be able to recover this data!",
    //         showDenyButton: true,
    //         confirmButtonText: "Yes",
    //         denyButtonText: `No, cancel!`,
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             deleteData({ id: entry_id });
    //         }
    //     });
    // };

    const columns = [
        {
            accessor: "so_number",
            header: "Sales Order number",
            cell: (row) => (
                <>{row?.sales_order ? row?.sales_order?.so_number : "-"}</>
            ),
        },
        {
            accessor: "work_order_code",
            header: "Work order code",
            cell: (row) => (
                <>{row?.work_order_code ? row?.work_order_code : "-"}</>
            ),
        },
        {
            accessor: "item_name",
            header: "Item Name",
            cell: (row) => <>{row?.sales_order?.product?.item_name ?? "-"}</>,
        },
        {
            accessor: "sales_order_approve_date",
            header: "Sales order approved date",
            // cell: (row) => (
            //     <>
            //         {row?.prod_start_date
            //             ? moment(row?.prod_start_date).format("DD-MM-YYYY")
            //             : "-"}
            //     </>
            // ),
            sortable: true,
        },
        {
            accessor: "prod_start_date",
            header: "Production Start date",
            cell: (row) => (
                <>
                    {row?.prod_start_date
                        ? moment(row?.prod_start_date).format("DD-MM-YYYY")
                        : "-"}
                </>
            ),
            sortable: true,
        },
        {
            accessor: "dispatch_date",
            header: "Dispatch Date",
            cell: (row) => (
                <>
                    {row?.dispatch_date
                        ? moment(row?.dispatch_date).format("DD-MM-YYYY")
                        : "-"}
                </>
            ),
            sortable: true,
        },
        {
            accessor: "target_quantity",
            header: "Target Quantity",
            cell: (row) => (
                <>{row?.target_quantity ? row?.target_quantity : "-"}</>
            ),
        },
        // {
        //     accessor: "status",
        //     header: "Status",
        //     filterable: true,
        //     filterType: "dropdown",
        //     filterOpt: TypeMasterQueryData.data
        //         ? TypeMasterQueryData.data?.results?.data?.map((type) => ({
        //               label: type?.name,
        //               value: type?.value,
        //           }))
        //         : [],
        // },
        ...(privileges.includes("work_order_split")
            ? [
                  {
                      accessor: "button",
                      header: "Action",
                      cell: (row) => (
                          <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={() => onFGoodsHandler(row)}
                          >
                              Split Work Order
                          </button>
                      ),
                  },
              ]
            : []),
    ];

    const handleSortingChnage = (value) => {
        console.log(value);
        setSorting(value);
    };

    console.log(error);

    if (isError)
        return (
            <Error
                message={error?.response?.data?.results?.message}
                code={error?.status}
            />
        );

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Work Order
                        </h3>
                    </div>
                    {/* {privileges.includes("work_order_create") && (
                        <div className="nk-block-head-content">
                            <NavLink
                                to="/create-work-order"
                                className="toggle btn btn-icon btn-primary d-md-none"
                                id="button-button-create-work-order"
                            >
                                <em className="icon ni ni-plus"></em>
                            </NavLink>

                            <NavLink
                                to="/create-work-order"
                                className="toggle btn btn-primary d-none d-md-inline-flex"
                                id="button-button-create-work-order"
                            >
                                <em className="icon ni ni-plus"></em>
                                <span>Create Work Order</span>
                            </NavLink>
                        </div>
                    )} */}
                </div>
            </div>

            <div id="accordion" className="accordion">
                <div className="accordion-item">
                    <a
                        href="#"
                        className="accordion-head"
                        data-bs-toggle="collapse"
                        data-bs-target={`#so-analytics`}
                    >
                        <h6 className="title">Analytics</h6>
                        <span className="accordion-icon"></span>
                    </a>
                    <div
                        className="accordion-body collapse"
                        id={`so-analytics`}
                        data-bs-parent="#accordion"
                    >
                        <div className="accordion-inner">
                            <h5>Key Performance Metrics</h5>
                            <WorkOrderPerformanceMetrix />
                            <div className="row g-3 mt-3">
                                <div className="col-lg-6 col-md-12">
                                    <PieChartComponent />
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <BarChartComponent />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Table
                data={data ? data.results.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                defaultGlobalSearchValue={
                    initialQueries.length > 0 && initialColumns.length <= 0
                        ? initialQueries[0]
                        : undefined
                }
                defaultColumnFiltersValue={
                    initialQueries.length > 0 && initialColumns.length > 0
                        ? initialColumns.map((column, index) => ({
                              id: column,
                              value: initialQueries?.[index] ?? "",
                          }))
                        : undefined
                }
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
                onSortingChange={handleSortingChnage}
            />
        </>
    );
};

export default WorkOrder;
